"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PostMessage = require("../api/PostMessage");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class ErrorBoundary extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({
      hasError: true
    });
    // eslint-disable-next-line no-console
    console.error(`ErrorBoundry caught error: ${JSON.stringify(error)} info: ${JSON.stringify(info)}`);
    _PostMessage.PostMessage.postMessageCoreError('ErrorBoundry caught error', {
      errorDetails: error.details
    });
  }
  render() {
    const {
      hasError
    } = this.state;
    const {
      children,
      fallback
    } = this.props;
    if (hasError) {
      return fallback ? {
        fallback
      } : /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, "We're sorry the request could not be processed. Please try again later."));
    }
    return children;
  }
}
ErrorBoundary.propTypes = {
  children: _propTypes.default.node.isRequired,
  fallback: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string])
};
var _default = exports.default = ErrorBoundary;
//# sourceMappingURL=ErrorBoundry.js.map